const imgTeamGraphic2Poster1 = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img12032 = "./assets/figma/7f2a7ce8-be0d-428a-8606-8c1344abe439.png";
const img2026923382 = "./assets/figma/221a0709-28db-4d8c-a722-6c06f1ed6284.png";
const img2026923372 = "./assets/figma/06d5533b-ffa3-4942-a40c-4910afc87dee.png";
const img2026923373 = "./assets/figma/01051303-3827-4a66-ab58-6b9c95b95078.png";
const img2026923383 = "./assets/figma/418cccde-c404-479a-9d33-5dd4ffac3b77.png";
const img2026923384 = "./assets/figma/499d08db-cdaa-42da-9329-1fa92527a224.png";
const img2026923385 = "./assets/figma/10b9af6d-7016-4cc1-bdab-56e95e2535e6.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgUntitled103Png1 = "./assets/figma/de64a4a1-6f51-4bd1-b4ff-3d45c6619dee.png";
const imgKakaoTalkPhoto20260915004831Png1 = "./assets/figma/582cbe0b-bff9-41c1-be6a-32d19f11e1a0.png";
const imgUntitled101Png1 = "./assets/figma/9ab95a5d-8800-4551-8eb9-be57cbac60c1.png";
const imgUntitled101Png2 = "./assets/figma/1d4bfeef-0d18-4624-b26a-bd9aa9b4aee0.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/0910cb02-95b1-474b-946c-10878436c4c0.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle246 = "./assets/figma/4089bed5-72aa-4d54-b8a7-191cd88f882f.svg";
const imgRectangle247 = "./assets/figma/0a0f13d0-9cdf-414b-9cf7-8d46976f3008.svg";
const imgClose = "./assets/figma/126d0178-fb8f-4298-97a5-6e9219784749.svg";

export default function TeamGraphic2Poster1() {
  return (
    <div className="s0 s1" data-node-id="875:1796" data-name="TEAM_GRAPHIC_2/POSTER1">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s7 s661 s9 s10 s662" src={imgTeamGraphic2Poster1} />
        </div>
      </div>
      <div className="s2 s12 s663 s617 s15" data-node-id="875:1798" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s664 s618 s22" data-node-id="875:1799">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:1800">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1801">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:1802">
            POSTERS · A2 · 4<br aria-hidden />
            GUIDE CARDS · 160 × 100 MM · 9<br aria-hidden />
            POSTCARDS · 100 × 150 MM · 8<br aria-hidden />
            <br aria-hidden />
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:1803">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:1804">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1805">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:1806">
            강다원
            <br aria-hidden />
            고이룸
            <br aria-hidden />
            박성연
            <br aria-hidden />
            박세현
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s619 s54" data-node-id="875:1807">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s665 s27 s29 s620 s57" data-node-id="875:1808">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:1809">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:1810">
          <p className="s39 s40">{`그래픽 2팀은 유리관을 연결하고 조립한 타이포그래피로 DING AI LAB의 이름과 실험실이라는 공간적 특성을 시각화했다. `}</p>
          <p className="s39 s40">{`기하학적 형태와 색의 그라데이션이 겹치고 어우러지는 배경을 통해 다양한 아이디어가 모여 조화를 이루는 모습을 표현했으며, `}</p>
          <p className="s39 s40">{`텍스트를 그래픽과 연결해 활동 순서와 슬로건의 정보 위계를 정리했다. 엽서에는 서로 다른 AI의 특성과 아이디어가 변화·확장되는 과정을 `}</p>
          <p className="s39 s40">{`고유 색상, 투명 파이프와 구체로 담았다. 8가지 AI 가이드 카드에는 핵심 기능, 활용 분야, 프롬프트 예시, 사용 팁과 주의사항을 캐릭터와 `}</p>
          <p className="s39">{`색상으로  구분해 복잡한 정보를 친근하고 명확하게 전달했다.`}</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s621 s27 s29 s61 s622 s54" data-node-id="875:1811">
        GRAPHIC 2
      </p>
      <div className="s2 s623 s666 s620 s625" data-node-id="875:1812" data-name="이미지 1203 2">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12032} />
      </div>
      <p className="s23 s2 s31 s32 s63 s27 s29 s64 s626 s66" data-node-id="875:1813">
        WORK
      </p>
      <div className="s2 s16 s17 s627 s18 s36 s63 s628 s66" data-node-id="875:1814">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1815">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:1816" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:1817" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1818" />
          <p className="s23 s192 s31 s32 s667 s346 s27 s0 s198 s29 s33 s85 s668" data-node-id="875:1819">
            POSTER 1
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1820">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:1821" data-name="이미지 2026. 9. 2. 오후 3.37 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s629 s630 s9 s631 s632" src={img2026923372} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s653 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:1822" />
          <div className="s80 s192 s81 s69 s633 s340 s82 s0 s70 s198 s71" data-node-id="875:1823" />
          <p className="s23 s192 s31 s94 s669 s346 s27 s0 s198 s29 s33 s85 s304" data-node-id="875:1824">
            POSTER 2
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1825">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:1826" data-name="이미지 2026. 9. 2. 오후 3.37 3">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923373} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:1827" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1828" />
          <p className="s23 s192 s31 s94 s670 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:1829">
            POSTER 3
          </p>
        </div>
      </div>
      <div className="s2 s16 s17 s627 s18 s36 s63 s639 s66" data-node-id="875:1830">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1831">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:1832" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s640 s9 s641 s343" src={img2026923383} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:1833" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1834" />
          <p className="s23 s192 s31 s32 s671 s346 s27 s0 s198 s29 s33 s85 s672" data-node-id="875:1835">
            POSTER 4
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1836">
          <div className="s192 s69 s673 s340 s0 s70 s198 s71" data-node-id="875:1837" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s674 s675 s9 s676 s677" src={img2026923384} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:1838" />
          <div className="s80 s192 s81 s69 s647 s340 s82 s0 s70 s198 s71" data-node-id="875:1839" />
          <p className="s23 s192 s31 s94 s678 s346 s27 s0 s198 s29 s33 s85 s679" data-node-id="875:1840">
            GUIDE CARDS
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1841">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:1842" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s7 s680 s9 s10 s681" src={img2026923385} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:1843" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1844" />
          <p className="s23 s192 s31 s94 s682 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:1845">
            POSTCARDS
          </p>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:1846">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s683 s108 s109" data-node-id="875:1847" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:1848">
          <div className="s111 s0 s28 s112" data-node-id="875:1849" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:1854">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:1855">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:1856">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1857">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1858">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:1859">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1860">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1861">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:1862">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1863">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1864">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s125 s126 s10 s104" data-node-id="875:2288">
        <div className="s2 s127">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:2289">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle247} />
        </div>
      </div>
      <div className="s106 s2 s67 s126 s684" data-node-id="875:1790">
        <div className="s2 s5 s685 s153 s156 s157 s684 s158" data-node-id="856:3306" />
        <p className="s23 s2 s31 s32 s686 s27 s29 s160 s687 s54" data-node-id="856:3307">
          POSTER 1
        </p>
        <div className="s106 s2 s67 s688 s689" data-node-id="856:3322">
          <div className="s106 s2 s690 s688 s165 s4 s145 s146 s689 s691" data-node-id="856:3323">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s692 s26 s693 s27 s29 s694 s695" data-node-id="856:3324">
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:3325">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3326">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s174 s34" data-node-id="856:3327">
                <p className="s175 s40">{`Transform Image 1 into a polished 3D glass-pipe typography artwork, using Image 2 as the visual reference. Preserve the original lettering, letter positions, scale, spacing, and staggered three-line layout: "DING" at the top, "Ai" in the middle left, and "LAB" at the bottom right. Keep the extended pipe-like strokes running beyond the top, left, and bottom edges.`}</p>
                <p className="s175 s40">Replace every solid black letter with hollow, transparent cylindrical glass tubing in pale aqua and icy cyan, with deep teal-blue edges and reflections. Construct the letterforms from straight tubes, smoothly curved elbows, and rounded bends. Add detailed transparent coupling rings and ridged glass joints at regular intervals and connection points, matching Image 2. The letters should look physically assembled from glass pipes, with visible inner walls, realistic refraction, glossy highlights, and subtle depth.</p>
                <p className="s175 s40">Place small, highly reflective dark cyan-blue spheres inside selected tubes, following their positions in Image</p>
                <p className="s175 s40">2. Center each sphere within the width of its tube.</p>
                <p className="s175 s40">{`Replace the dot above the lowercase "i" with a matching floating glass sphere.`}</p>
                <p className="s175">Maintain the clean white background, generous negative space, portrait aspect ratio, and straight-on view. Use crisp studio lighting and sharp, high-resolution detail. Do not add extra text, objects, textures, or decorative elements. Match the composition, glass material, colors, and joint details of Image 2 as closely as possible.</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:3328">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3329">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:3330">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
        <div className="s2 s696 s697 s698 s699" data-node-id="856:3331" data-name="Untitled-1-03.png 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgUntitled103Png1} />
        </div>
        <div className="s2 s700 s189 s698 s701" data-node-id="856:3332" data-name="KakaoTalk_Photo_2026-09-15-00-48-31.png 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto20260915004831Png1} />
        </div>
        <div className="s2 s702 s189 s703 s704" data-node-id="856:3333" data-name="Untitled-1-01.png 1">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s705 s706 s9 s707 s708" src={imgUntitled101Png1} />
          </div>
        </div>
        <div className="s2 s709 s189 s689 s710" data-node-id="856:3334" data-name="Untitled-1-01.png 2">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s711 s712 s9 s713 s714" src={imgUntitled101Png2} />
          </div>
        </div>
        <p className="s23 s2 s31 s32 s715 s27 s29 s137 s716 s54" data-node-id="856:3335">
          PROCESS
        </p>
      </div>
      <div className="s2 s16 s17 s24 s130 s26 s20 s132 s133" data-node-id="875:2770" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
        <p className="s23 s31 s32 s27 s0 s28 s137 s138 s34" data-node-id="875:2771">
          GRAPHIC 2
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s34" data-node-id="875:2772" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="875:2773" data-name="TAB_POSTER1">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="875:2774">
              POSTER 1
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="875:2775" data-name="TAB_POSTER2">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="875:2776">
              POSTER 2
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="875:2777" data-name="TAB_POSTER3">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="875:2778">
              POSTER 3
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="875:2779" data-name="TAB_POSTER4">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="875:2780">
              POSTER 4
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="875:2781" data-name="TAB_GUIDECARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="875:2782">
              GUIDE CARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="875:2783" data-name="TAB_POSTCARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="875:2784">
              POSTCARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="908:209" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
    </div>
  );
}